import { LOAD_HOW_TO_GUIDES, LOAD_HOW_TO_GUIDES_ERROR } from "../actions/types";

const initialState = {
  guides: [],
  errors: {},
  loading: true,
};

export default function howToGuidesReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_HOW_TO_GUIDES:
      return {
        ...state,
        loading: false,
        guides: payload,
        errors: {},
      };
    case LOAD_HOW_TO_GUIDES_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    default:
      return state;
  }
}
